export const isSame = (a, b) => {
    if (!a && !b) return false;
    return String(a || '').localeCompare(String(b || '')) === 0;
};

export const getCellClass = (css, hasData, baseClass) => `${baseClass} ${!hasData ? css.emptyCell : ''}`;

export const splitCsv = (s) =>
    s
        ? s
              .split(',')
              .map((x) => x.trim())
              .filter(Boolean)
        : [];
export const joinCsv = (arr) => (Array.isArray(arr) ? arr.join(',') : '');

export const pad2 = (n) => String(n).padStart(2, '0');
export const hhmmToHhmmss = (hhmm) => (hhmm ? `${hhmm}:00` : '00:00:00');
export const sliceHhmm = (hhmmss) => (hhmmss ? hhmmss.slice(0, 5) : '00:00');

// Helper function to convert duration string to minutes
export const durationToMinutes = (duration) => {
    if (!duration) return 0;
    const [hours, minutes] = duration.split(':').map(Number);
    return (hours || 0) * 60 + (minutes || 0);
};

// Helper function to convert minutes back to HH:MM format
export const minutesToDuration = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
};

// Helper function to convert seconds back to HH:MM format
export const secondsToDuration = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
};

// Helper function to get duration for a specific ATA in a module
export const getAtaDuration = (module, ataId) => {
    if (!module?.ata) return '00:00';
    const ataInModule = module.ata.find((el) => el.ataId === ataId);
    return ataInModule?.duration || '00:00';
};

// Helper function to get level for a specific ATA in a module
export const getAtaLevel = (module, ataId) => {
    if (!module?.ata) return '';
    const ataInModule = module.ata.find((el) => el.ataId === ataId);
    return ataInModule?.level || '';
};
